function Footer() {
  return (
    <footer className="bg-dark text-white text-center py-3">
      <p className="mb-0">&copy; 2025 Comercial AC 2025, C.A. - Todos los derechos reservados</p>
    </footer>
  );
}

export default Footer;